import image from 'shared/assets/images/integrationsSliders/attio/attio.png'
import { LINK_ATIO_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const attio: IntegrationDetailsData = {
  subheadline: 'Power your modern CRM with direct messaging capabilities.',
  overview:
    'Connect Salesmsg with Attio to streamline your workflow and keep your CRM data up to date. When you engage with contacts through Salesmsg, relevant information flows to Attio, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and CRM workflows',
  ],
  images: [image],
  docs: LINK_ATIO_INTEGRATION_GUIDE,
}
